import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/diensten")({
  beforeLoad: () => {
    throw redirect({ to: "/", hash: "diensten" });
  },
  component: () => null,
});
